import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  accountCombineHasParallerCompany() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现提示-有平行公司'
    });
  },
  accountCombineFinishParallerCompanyChoose() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-完成平行公司选择'
    });
  },
  accountCombineShowParallerCompanyChoose(index) {
    const op = {
      1: '有平行账号选择',
      2: '没有平行账号'
    };
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级提示',
      eventLabel: op[index]
    });
  },
  accountCombineImmediateUpgrade() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-立即升级'
    });
  },
  accountCombineNotYetUpgrade() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-暂不升级'
    });
  },
  accountCombineUpgrade11() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景1.1'
    });
  },
  accountCombineUpgrade11ChooseHpc() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-升级场景1.1-选择HPC公司'
    });
  },
  accountCombineUpgrade11ChooseEP() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-升级场景1.1-选择EP公司'
    });
  },
  accountCombineUpgrade12() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景1.2'
    });
  },
  accountCombineUpgrade13() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景1.3'
    });
  },
  accountCombineUpgrade14() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景1.4'
    });
  },
  accountCombineUpgrade14ChooseHpc() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-升级场景1.4-选择HPC公司'
    });
  },
  accountCombineUpgrade14ChooseEP() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-升级场景1.4-选择EP公司'
    });
  },
  accountCombineUpgrade1ChoseUserInfo() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-升级场景1-出现确认个人信息弹窗'
    });
  },
  accountCombineUpgrade1FinishUserInfo() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-升级场景1-完成个人信息确认'
    });
  },
  accountCombineUpgrade2() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景2'
    });
  },
  accountCombineUpgrade3() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景3'
    });
  },
  accountCombineUpgrade41() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景4.1'
    });
  },
  accountCombineUpgrade42() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景4.2'
    });
  },
  accountCombineUpgrade42Home() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景4.2-进入home页'
    });
  },
  accountCombineUpgrade5() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景5'
    });
  },
  accountCombineUpgrade6() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景6'
    });
  },
  accountCombineUpgrade7and8() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-出现升级场景7&8'
    });
  },
  accountCombineUpgrade2LoginShowParallerCompany() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-二次登陆-出现平行公司'
    });
  },
  accountCombineUpgrade2LoginNoParallerCompany() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-二次登陆-没有平行公司'
    });
  },
  accountCombineUpgrade2LoginChangeParallerCompany() {
    buryPoint.event({
      eventCategory: 'HPC账号和EP 1.0的账号合并',
      action: 'HPC账号和EP 1.0的账号合并-平行公司切换'
    });
  }
};